import {
  AURELIA_OUTBOX_FOLDER,
  OUTBOX_FOLDER_LABEL,
  SCHEDULED_OUTBOX_LABEL,
  SENDING_FOLDER_LABEL,
} from "@/lib/outbox/constants";
import { NAV_FOLDER_LABELS } from "@/lib/mail/folderNavSections";
import type { MailFolder } from "@/lib/types/mail";

export type OutboxNavRow = {
  key: string;
  folder: MailFolder;
  sendingActive?: boolean;
};

export type AccountOutboxState = {
  queueCount: number;
  sendingCount: number;
  failedCount: number;
  scheduledCount: number;
  /** POST de programmation (placeholder) — pas l’envoi SMTP. */
  schedulingPending?: boolean;
};

export function accountOutboxTotalCount(state: AccountOutboxState): number {
  return state.scheduledCount + state.queueCount;
}

/** Échec, puis envoi en cours, puis programmé, puis file. */
export function resolveOutboxNavLabel(state: AccountOutboxState): string {
  if (state.failedCount > 0) return "Échec d'envoi";
  if (state.sendingCount > 0) return SENDING_FOLDER_LABEL;
  if (state.scheduledCount > 0) return SCHEDULED_OUTBOX_LABEL;
  if (state.queueCount > 0) return OUTBOX_FOLDER_LABEL;
  return NAV_FOLDER_LABELS.outbox;
}

/**
 * Entrée unique « Envoi programmé » — file locale Aurelia (pas un dossier IMAP du compte).
 * Toujours visible dans la barre principale.
 */
export function buildOutboxNavRows(state: AccountOutboxState): OutboxNavRow[] {
  const total = accountOutboxTotalCount(state);
  return [
    {
      key: AURELIA_OUTBOX_FOLDER,
      folder: {
        name: AURELIA_OUTBOX_FOLDER,
        label: resolveOutboxNavLabel(state),
        depth: 0,
        unread: total > 0 ? total : 0,
      },
      sendingActive: state.sendingCount > 0,
    },
  ];
}
